/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('Category_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl + 'rest/categories/:id',{}, {
            query: { method: 'GET', isArray: false },
            getTree: { method: 'GET', isArray: false , url:baseUrl+'rest/categories/tree'},
            getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/categories/deleted'},
            duplicateCategory: { method: 'GET', isArray: false, url:baseUrl+'rest/categories/duplicate/:id'},
            countCurrentServices : { method: 'GET', isArray: false, url:baseUrl+'rest/categories/count-current-services'},
            get:   { method: 'GET' }
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Category',["Category_Resource","Service","CategoryData","ServiceData","ImageData","CompanyImageData","HrRootCategory",
        function (Category_Resource,Service,CategoryData,ServiceData,ImageData,CompanyImageData,HrRootCategory)
    {
        var Category = function (rsCategory,parentCategory)
        {
            this.id = null;
            this.isDeleted;
            this.label = "";
            this.description = "";
            this.image = null;
            this.companyImage = null;
            this.specificImage;//boolean
            this.isVisibleOnWebSite;
            this.style = "";
            this.displayType = null;

            this.services = [];
            this.categories = [];
            this.version = null;

            if (parentCategory!==undefined && parentCategory!=null)
                this.parentCategory=  parentCategory;

            if (rsCategory!==undefined && rsCategory!=null)
            {
                var service,category;
                if (!this.id)
                    this.id = rsCategory.id;
                this.isDeleted = rsCategory.isDeleted;
                this.label = rsCategory.label;
                this.description = rsCategory.description;
                this.imageId =  rsCategory.imageId;
                this.companyImageId =  rsCategory.companyImageId;
                this.specificImage = rsCategory.specificImage;
                this.isVisibleOnWebSite = rsCategory.isVisibleOnWebSite;
                this.parentCategoryId =  rsCategory.parentCategoryId;
                this.style = rsCategory.style;
                if (rsCategory.displayType)
                    this.displayType = rsCategory.displayType;
                if (rsCategory.version)
                    this.version = rsCategory.version;
                if ( rsCategory.categories)
                    for (var i=0;i< rsCategory.categories.length;i++)
                    {
                        category = new Category(rsCategory.categories[i],this);
                        this.categories.push(category);
                    }

                if ( rsCategory.services)
                    for (var j=0;j< rsCategory.services.length;j++)
                    {
                        service = new Service(rsCategory.services[j],this);
                        this.services.push(service);
                    }
            }
            CategoryData.add(this);
        }

        Category.prototype.loadObject = function(object,parentCategory)
        {
            this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.description = object.description;
            this.style= object.style;
            if (object.displayType)
                this.displayType = object.displayType;
            this.specificImage = object.specificImage;
            this.isVisibleOnWebSite = object.isVisibleOnWebSite;
            if (object.version)
                this.version = object.version;
            if (parentCategory!==undefined && parentCategory!=null)
            {
                this.parentCategory=  parentCategory;
            }

            //load ref from ids
            if (object.servicesId)
            {
                var newServices = [];
                for (var i=0;i<object.servicesId.length;i++)
                {
                    var service =  ServiceData.getById(object.servicesId[i]);
                    if (service!=null)
                        newServices.push(service);
                }
                this.services = newServices;
            }
            if (object.categoriesId)
            {
                var newCategories = [];
                for (i=0;i<object.categoriesId.length;i++)
                {
                    var category =  CategoryData.getById(object.categoriesId[i]);
                    if (category!=null)
                        newCategories.push(category);
                }
                this.categories = newCategories;
            }


        }
        Category.prototype.getObjectResource = function()
        {
            var rsCategory = new Category_Resource();
            rsCategory.id = this.id ;
            rsCategory.isDeleted = this.isDeleted;
            rsCategory.label =this.label;
            rsCategory.description =this.description;
            if (this.image)
                rsCategory.imageId = this.image.id;
            if (this.companyImage)
                rsCategory.companyImageId = this.companyImage.id;
            rsCategory.specificImage = this.specificImage;
            rsCategory.isVisibleOnWebSite = this.isVisibleOnWebSite;
            rsCategory.style = this.style;
            if (this.displayType)
                rsCategory.displayType = this.displayType;

            if (this.parentCategory)
                rsCategory.parentCategoryId = this.parentCategory.getId();
            rsCategory.categoriesId = [];
            for (var i=0;i< this.categories.length;i++)
                rsCategory.categoriesId.push( this.categories[i].getId());
            rsCategory.servicesId = [];
            for (var i=0;i< this.services.length;i++)
                rsCategory.servicesId.push(this.services[i].getId());
            return rsCategory;
        }
        Category.prototype.getId = function()
        {
            return this.id;
        }
        Category.prototype.setId = function(id)
        {
            this.id = id;
        }
        Category.prototype.getLabel = function()
        {
            return this.label;
        }
        Category.prototype.addService = function(service)
        {
            if (service) {
                var index = this.services.indexOf(service);
                if (index == -1)//Not already there
                {
                    this.services.push(service);
                    service.parentCategory = this;
                }
            }
        }
        Category.prototype.removeService = function(service)
        {
            var index = this.services.indexOf(service);
            if (index!=-1)//Found
            {
                this.services.splice(index,1);
            }

        }
        Category.prototype.addCategory = function(category)
        {
            if (category)
            {
                var index = this.categories.indexOf(category);
                if (index==-1)//Not already there
                {
                    this.categories.push(category);
                    category.parentCategory = this;
                }
            }
        }
        Category.prototype.removeCategory = function(category)
        {
            var index = this.categories.indexOf(category);
            if (index!=-1)//Found
            {
                this.categories.splice(index,1);
            }

        }
        Category.prototype.changeServicePosition = function(service,indexTarget)
        {
            //Change the service position
            var index = this.services.indexOf(service);
            if (indexTarget!=-1 && index!=-1 && indexTarget!=index && this.services && indexTarget<this.services.length)
            {
                var cat = this.services[indexTarget];

                this.services.splice(index,1);
                if (index<indexTarget)
                    indexTarget--;
                this.services.splice(indexTarget,0,service);

            }

        }
        Category.prototype.getServiceById =  function(serviceId)
        {
            //recursive research
            var service = null;
            for (var j = 0; j < this.services.length; j++)
                if (this.services[j].id == serviceId)
                    return this.services[j];
            for (var z=0;z< this.categories.length && !service;z++)
                service = this.categories[z].getServiceById(serviceId);

            return service;
        }
        Category.prototype.getServiceByLabel =  function(serviceLabel)
        {
            //recursive research, need lower case input
            var service = null;
            for (var j = 0; j < this.services.length; j++)
                if (this.services[j].label.toLowerCase() == serviceLabel)
                    return this.services[j];
            for (var z=0;z< this.categories.length && !service;z++)
                service = this.categories[z].getServiceByLabel(serviceLabel);

            return service;
        }
        Category.prototype.getCategoryById =  function(categoryId)
        {
            //recursive research
            var category = null;
            for (var z=0;z< this.categories.length && !category;z++)
                if (this.categories[z].id == categoryId)
                    category= this.categories[z];
                else
                    category = this.categories[z].getCategoryById(categoryId);
            return category;
        }
        Category.prototype.loadRef =  function()
        {
            if (this.imageId)
                this.image = ImageData.getById(this.imageId);
            if (this.companyImageId)
                this.companyImage = CompanyImageData.getById(this.companyImageId);
            if (this.parentCategory==null && this.parentCategoryId)
                this.parentCategory = CategoryData.getById(this.parentCategoryId);
        }
        Category.prototype.getSubStatCategories =  function(rootCategory)
        {
            return this.categories.concat(this.services);
        }

        Category.prototype.isDescendantOf = function(category) {
            var isDescendantOf = false;
            if(this.parentCategory === category) {
                isDescendantOf = true;
            }
            else {
                if(this.parentCategory) {
                    isDescendantOf = this.parentCategory.isDescendantOf(category);
                }
            }

            return isDescendantOf;
        }

        return Category;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CategorySrv',["Category_Resource","Category","CategoryData","UserActionData","ServiceSrv","$log","ServerSrv","Constants",
        function (Category_Resource,Category,CategoryData,UserActionData,ServiceSrv,$log,ServerSrv,Constants)
    {
        //$timeout (function () {

        var  categorySrv = {};
        categorySrv.query = function(successFunction,errorFunction)
        {
            var treeLoaded = false;
            var deletedLoaded = false;
            Category_Resource.getTree(
                {}, //params
                function (data) {   //success
                    CategoryData.categoryRoot = new Category(data);

                    if (successFunction !== undefined && deletedLoaded)
                        successFunction(CategoryData.categoryRoot);
                    treeLoaded = true;
                },
                function (data) {   //failure
                    $log.error("Category_Resource.getTree error");
                    $log.error(data);
                    if (errorFunction!== undefined && deletedLoaded)
                        errorFunction(data);
                    treeLoaded = true;
                });
            Category_Resource.getDeleted(
                {}, //params
                function (data) {   //success
                    CategoryData.deletedCategories = [] ;
                    for (var i=0;i< data.length;i++)
                        new Category(data[i]);//Auto Add to CategoryData

                    if (successFunction!== undefined && treeLoaded)
                        successFunction(CategoryData.categoryRoot);
                    deletedLoaded = true;
                },
                function (data) {   //failure
                    $log.error("Category_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined && treeLoaded)
                        errorFunction(data);
                    deletedLoaded = true;

                }
            );
        };
        categorySrv.duplicateCategory = function(category, successFunction, errorFunction) {
            Category_Resource.duplicateCategory({id: category.id},
                function (data) {
                if(successFunction) {
                    successFunction(data);
                    }
                },
                function () {
                    if (errorFunction !== undefined) {
                        errorFunction();
                    }
                });
        };
        categorySrv.countCurrentServices = function(successFunction, errorFunction) {
            Category_Resource.countCurrentServices(function (data) {
                    if(successFunction && data && data.numberOfCurrentServices < Constants.MAX_SERVICES_FOR_COMPANY) {
                        successFunction();
                    } else if(errorFunction) {
                        errorFunction(data, MAX_SERVICES_FOR_COMPANY);
                    }
                });
        };
        categorySrv.save = function(category,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(categorySrv.saveSync, category, successFunction, errorFunction);
        };
        categorySrv.saveSync = function(category,successFunction,errorFunction)
        {
            //$timeout (function () {

            var CategoryRes = category.getObjectResource();
            CategoryRes.$save({}, //no params
                function (data) {

                    try {
                        category.setId(data.id);
                        //TODO  UserActionData.add(data.userAction);
                        if (successFunction) {
                            successFunction(data);
                        }
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        categorySrv.remove =  function(category,successFunction,errorFunction)
        {
            CategoryData.remove(category);
            ServerSrv.startSavingProcess(categorySrv.removeSync, category, successFunction, errorFunction);
        };
        categorySrv.removeSync =  function(category,successFunction,errorFunction)
        {
            //$timeout (function () {

            var categoryRes = new Category_Resource()
            categoryRes.$remove({id:category.getId()}, //params : id
                function (data) {
                    try {
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction != undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        categorySrv.restore =  function(category,successFunction,errorFunction)
        {
            CategoryData.restore(category);
            ServerSrv.startSavingProcess(categorySrv.restoreSync, category, successFunction, errorFunction);
        };
        categorySrv.restoreSync =  function(category,successFunction,errorFunction)
        {
            //$timeout (function () {

            var categoryRes = category.getObjectResource();
            categoryRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        categorySrv.getCategoryOnServer =  function(scope,targetName,categoryId)
        {

            var category = null
            if (CategoryData.categoryRoot.categories!=null && CategoryData.categoryRoot.categories.length>0)
            {
                for (var i=0;i<CategoryData.categoryRoot.categories.length && !category;i++)
                    if (CategoryData.categoryRoot.categories[i].getId()==categoryId)
                        category = CategoryData.categoryRoot.categories[i];
                    else
                        for (var j=0;j<CategoryData.categoryRoot.categories[i].categories.length && !category;j++)
                            if (CategoryData.categoryRoot.categories[i].categories[j].getId()==categoryId)
                                category = CategoryData.categoryRoot.categories[i].categories[j];

                scope[targetName] =  category;
            }
            else
            {

                Category_Resource.get(
                    {id:categoryId},
                    function (categoryRes) {   //success
                        var bookingServices = [];

                        scope[targetName] = new Category(categoryRes);
                    },
                    function (categoryRes) {   //failure
                        //error handling goes here
                    });
            }
        };
        categorySrv.get =  function(categoryId)
        {
            //TODO
            return null;
        };
        categorySrv.getServiceById =  function(serviceId)
        {
            if (CategoryData.categoryRoot!=null)
            return CategoryData.categoryRoot.getService(serviceId);
        };
        categorySrv.loadRef =  function()
        {
            var categories = CategoryData.indexCategories;
            for (var i=0;i<categories.length;i++)
                categories[i].loadRef();

        };
        categorySrv.moveService = function(category,service)
        {
            if (category)
            {
                category.moveService(service);
                ServiceSrv.save(service);

            }
        };
        categorySrv.updateLocally =  function(object)
        {
            var category = null;
            var parentCategory = null;
            if (object.parentCategoryId)//Optimization : get parent if exist
            {
                parentCategory = CategoryData.getById(object.parentCategoryId);
                if  (parentCategory!=null)
                    category = parentCategory.getCategoryById(object.id);
            }
            else
                category = CategoryData.getById(object.id);
            if (category!=null)
                category.loadObject(object,parentCategory);
        };
        categorySrv.addLocally =  function(object)
        {
            //TODO
/*            var category = CategoryData.getCategory(object.parentCategoryId);
            if (category!=null)
                category.addService(new Service(object,category));*/

        };
        categorySrv.removeLocally =  function(object)
        {
            //TODO
/*            var service =  null;
            var category = CategoryData.getCategory(object.parentCategoryId);
            if (category!=null)
                service = category.getService(object.id)
            if (service!=null)
                category.removeService(service);*/
        };

        return categorySrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CategoryData',["$log", function ($log)
    {
        var  categoryData =
        {
            categoryRoot : null,
            indexCategories : [], //Used as Index
            deletedCategories : []
        };
        categoryData.getById =  function(categoryId)
        {
            for (var i=0;i<this.indexCategories.length;i++)
                if (this.indexCategories[i].id==categoryId)
                    return this.indexCategories[i];
            return null;
        }
        categoryData.getByIndex =  function(catIndex)
        {
            if (catIndex>=0 && catIndex<this.indexCategories.length)
                return this.indexCategories[catIndex];
            else
                return null;
        }
        categoryData.getIndexOf =  function(category)
        {
            if (category)
                return this.indexCategories.indexOf(category);
            return -1;
        }
        categoryData.add =  function(category)
        {
            this.indexCategories.push(category);
            if (category.isDeleted)
            {
                var index = this.deletedCategories.indexOf(category)
                if (index==-1)
                    this.deletedCategories.push(category);
            }
            return this.indexCategories.length-1;
        }
        categoryData.remove =  function(category) //Soft Remove
        {
            var index =  this.deletedCategories.indexOf(category);
            if (index==-1)
            {
                this.deletedCategories.push(category)
                category.isDeleted=true;
            }

        }
        categoryData.restore =  function(category) //Soft Remove
        {
            var index =  this.deletedCategories.indexOf(category);
            if (index!=-1)
            {
                this.deletedCategories.splice(index,1)
                category.isDeleted=false;
            }

        }
        categoryData.clear =  function()
        {
            categoryData.categoryRoot = null;
            categoryData.indexCategories = [];
            categoryData.deletedCategories = [];
        }
        categoryData.loaded =  function()
        {
            return (categoryData.categoryRoot != null);
        }
        categoryData.getDeletedList =  function()
        {
            return categoryData.deletedCategories;
        }

        return categoryData;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/Category.js